riot.tag2('bbc-notifications-signed-out-view', '<div class="notifications-main notifications-main--css notifications-main--js notification-signed-out"> <div class="notifications-wide-spread"> <div class="notifications__container"> <div class="notifications-top-header"> <p class="notifications-main-header notifications-trafalgar"><i1-8n>copy.upsell.title</i1-8n></p> <p class="notifications-description notifications-pica"><i1-8n>copy.upsell.body</i1-8n></p> </div> <div class="notifications-cta notifications-cta--upsell"> <bbc-notifications-idcta-html html="{opts.state.idctaResponse.html}" html-js="{opts.state.idctaResponse.htmlJs}" track-upsell-sign-in="{this.trackUpsellSignIn}" track-upsell-register="{this.trackUpsellRegister}"></bbc-notifications-idcta-html> </div> </div> </div> </div>', '', '', function(opts) {
'use strict';

var notificationsAnalytics = require('../analytics');

this.trackUpsellSignIn = function () {
    console.log('Tracking upsell sign in');
    notificationsAnalytics.log('sign-in', 'notifications-upsell');
    return true;
};

this.trackUpsellRegister = function () {
    console.log('Tracking upsell register');
    notificationsAnalytics.log('register', 'notifications-upsell');
    return true;
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-signed-out-view.tag
 ** module id = 31
 ** module chunks = 0
 **/